// @ts-nocheck
import { useEffect, useState } from 'react';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Loader2 } from 'lucide-react';
import CollapsibleSection from './CollapsibleSection';
import HeadingInfo from './HeadingInfo';
import { getLanguages } from '@/service/aiAgentApi';


export default function LanguagesSection({ value, onChange }: any) {
  const [languages, setLanguages] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getLanguages()
      .then((list) => {
        if (cancelled) return;
        setLanguages(Array.isArray(list) ? list : []);
        setError('');
      })
      .catch((err) => {
        if (cancelled) return;
        setError(typeof err === 'string' ? err : 'Failed to load languages');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const handleSelect = (code: string) => {
    const match = languages.find((l) => l.code === code);
    onChange({ id: match?.id ?? null, code, name: match?.language || match?.name || code });
  };

  return (
    <CollapsibleSection title="Languages">
      <div className="space-y-4">
        <p className="text-sm font-semibold text-foreground">Languages</p>
        <p className="mt-1 text-xs text-muted-foreground">
          Choose the language your agent will use to communicate.
        </p>

        <div className="space-y-1.5">
          <Label className="flex items-center gap-1.5">
            Language
            <HeadingInfo text="The language the agent speaks and understands on calls." />
          </Label>
          <Select value={value || undefined} onValueChange={handleSelect} disabled={loading || !!error}>
            <SelectTrigger className="max-w-xs">
              {loading ? (
                <span className="flex items-center gap-2 text-muted-foreground">
                  <Loader2 className="h-3.5 w-3.5 animate-spin" /> Loading languages…
                </span>
              ) : (
                <SelectValue placeholder="Select a language…" />
              )}
            </SelectTrigger>
            <SelectContent>
              {languages.map((l) => (
                <SelectItem key={l.id} value={l.code}>
                  {l.language || l.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {error && <p className="text-xs text-destructive">{error}</p>}
        </div>
      </div>
    </CollapsibleSection>
  );
}
